import React from 'react';
import { ensuredForwardRef } from 'react-use';
import { HiddenInput } from '../checkbox/styled';
import { StyledRadio, StyledLabelRadio } from './styled';
/**
 * Props for the Radio component
 * @typedef {object} RadioPropsT
 * @property {boolean} checked - Indicates whether the radio button is checked.
 * @property {string} label - The label text for the radio button.
 * @property {string} name - The name attribute for the radio button.
 * @property {function} onChange - Function to call when the radio button state changes.
 * @property {string} value - The value attribute for the radio button.
 * @property {string} [id] - Optional ID attribute for the radio button.
 * @property {string} [className] - Optional class name for additional styling.
 * @property {boolean} [disabled = false] - Indicates whether the radio button is disabled.
 * @property {number} [tabIndex] - Optional tab index for the radio button.
 */
const Radio = ensuredForwardRef(function Radio({ checked, label, onChange, disabled = false, ...props }, ref) {
    const onClick = onChange;
    return (React.createElement(StyledLabelRadio, { checked: checked, disabled: disabled },
        React.createElement(HiddenInput, { ref: ref, type: "radio", checked: checked, disabled: disabled, onClick: onClick, onChange: onChange, ...props }),
        React.createElement(StyledRadio, { checked: checked, disabled: disabled }),
        label));
});
export default Radio;
